// PainScoreInput.jsx
import React, { useEffect, useState } from "react";
import NavigateBack from "../../components/navigateBack";
import createPersistedState from "use-persisted-state";
import { makeStyles, Slider } from "@material-ui/core";

import Emoji1 from "../../img/painEmoji/Group 1141.svg";
import Emoji2 from "../../img/painEmoji/Group 1142.svg";
import Emoji3 from "../../img/painEmoji/Group 1143.svg";
import Emoji4 from "../../img/painEmoji/Group 1144.svg";
import Emoji5 from "../../img/painEmoji/Group 1145.svg";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { YouTube } from "@material-ui/icons";

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useProfileState = createPersistedState("profile");

const PainScore = () => {
  const [score, setScore] = useState(0);

  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [profile, ___] = useProfileState();
  const history = useHistory();

  const [isAppointmentLoading, setIsAppointmentLoading] = useState(false);
  const [currentAppointment, setCurrentAppointment] = useState(null);

  const [isPainScoreStatusLoading, setIsPainScoreStatusLoading] =
    useState(false);
  const [isPainScoreEnabled, setIsPainScoreEnabled] = useState(null);
  const [isASAssessmentEnabled, setIsASAssessmentEnabled] = useState(false);
  const [isRAAssessmentEnabled, setIsRAAssessmentEnabled] = useState(false);

  const [isPainScoreLoading, setIsPainScoreLoading] = useState(false);

  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const [isPainScoreSubmitting, setIsPainScoreSubmitting] = useState(false);

  const useStyles = makeStyles({
    root: {
      height: 10,
      marginTop: 10,
    },
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: "var(--darkbluecolorone)",
      marginTop: -7,
      marginLeft: -12,
    },
    track: {
      height: 10,
      borderRadius: 5,
      backgroundColor: "var(--darkbluecolorone)",
    },
    rail: {
      height: 10,
      borderRadius: 5,
    },
    valueLabel: {
      left: "calc(-50% + 8px)", // adjust X alignment (matches thumb offset)
      top: -30, // adjust Y alignment as needed
      color: "var(--darkbluecolorone)",
    },
  });

  const classes = useStyles();

  const getMyAppointmentsUrl = (pid) =>
    `/api/v1/appointments?attendeeId=${pid}`;

  const fetchAppointmentInfo = async (pid) => {
    return fetch(getMyAppointmentsUrl(pid), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          setCurrentAppointment(responseData["appointment"]);
          return responseData["appointment"];
        } else if (responseData["status"]["code"] === 4011) {
          localStorage.clear();
          history.push("/login");
        }
      })
      .catch(function (error) {
        console.log(error.message); //TODO: Report error
        //history.push("/login");
      })
      .finally(() => {
        setIsPainScoreLoading(false);
      });
  };

  const fetchPainScoreStatus = async () => {
    const url = `/api/v1/pain-score/status/`;

    setIsPainScoreStatusLoading(true);

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          const assessmentConfig = responseData["painScoreConfig"];

          const isASTestFlagEnabled =
            assessmentConfig?.enableBASDAI === true ||
            assessmentConfig?.enableBASFI === true;

          const isRATestFlagEnabled = assessmentConfig?.enableRAPID3 === true;

          setIsPainScoreEnabled(responseData["enabled"]);
          setIsASAssessmentEnabled(isASTestFlagEnabled);
          setIsRAAssessmentEnabled(isRATestFlagEnabled);

          return responseData["enabled"];
        } else if (responseData["status"]["code"] === 4011) {
          localStorage.clear();
          history.push("/login");
        }
      })
      .catch(function (error) {
        console.log(error.message); //TODO: Report error
        //history.push("/login");
      })
      .finally(() => {
        setIsPainScoreStatusLoading(false);
      });
  };

  const fetchPainScore = async () => {
    const url = `/api/v1/pain-score/general/${pid}`;

    setIsPainScoreLoading(true);

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          responseData["current"] && setScore(responseData["current"]["value"]);
          return responseData["current"];
        } else if (responseData["status"]["code"] === 4011) {
          localStorage.clear();
          history.push("/login");
        }
      })
      .catch(function (error) {
        console.log(error.message); //TODO: Report error
        //history.push("/login");
      })
      .finally(() => {
        setIsPainScoreLoading(false);
      });
  };

  const requestUpdatePainScore = async (appointmentId, score) => {
    const url = `/api/v1/pain-score/general/${appointmentId}`;

    setIsPainScoreSubmitting(true);

    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        value: score,
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          return responseData["status"];
        } else if (responseData["status"]["code"] === 4011) {
          localStorage.clear();
          history.push("/login");
        }
      })
      .catch(function (error) {
        console.log(error.message); //TODO: Report error
        //history.push("/login");
      })
      .finally(() => {
        setIsPainScoreSubmitting(false);
      });
  };

  const fetchInitialData = async () => {
    setIsInitialLoading(true);
    try {
      // First call: Check pain score status
      const isEnabled = await fetchPainScoreStatus();

      if (isEnabled) {
        // Parallelize these if they don't depend on each other
        await Promise.all([fetchAppointmentInfo(pid), fetchPainScore()]);
      }
    } catch (error) {
      console.error("Error in initial data loading:", error);
      // Optionally show error to user
    } finally {
      setIsInitialLoading(false);
    }
  };

  // Usage in component
  useEffect(() => {
    if (pid) {
      fetchInitialData();
    }
  }, [pid]);

  return (
    <>
      <NavigateBack title="Pain Score" />
      {isInitialLoading && (
        <div className="body_content">
          <div className="inner_body py-5">
            <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
              }}
              id="loader"
            ></div>
          </div>
        </div>
      )}
      {!isInitialLoading && (
        <div className="p-4" style={{ marginTop: "75px" }}>
          <div className={isPainScoreEnabled ? "" : "opacity-25 pe-none"}>
            <h2 className="text-xl font-semibold mb-4">
              What is your pain level in last 24 hours?
            </h2>
            <div className="d-flex justify-content-around mb-4 fs-1">
              <span
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={Emoji5} />
              </span>
              <span
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={Emoji3} />
              </span>
              <span
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={Emoji2} />
              </span>
              <span
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={Emoji1} />
              </span>
              <span
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={Emoji4} />
              </span>
            </div>
            <Slider
              value={score}
              onChange={(e, newValue) => {
                setScore(newValue);
              }}
              onChangeCommitted={async (e, newValue) => {
                requestUpdatePainScore(currentAppointment?.id, newValue);
              }}
              classes={classes}
              min={0}
              max={10}
              step={1}
              marks
              valueLabelDisplay="auto"
            />
            <div className="d-flex justify-content-between mt-2 text-sm w-100">
              <span>0 - Best</span>
              <span>Worst - 10</span>
            </div>

            <div
              className="m-auto my-2 text-center fst-italic"
              style={{ color: "#F6781B" }}
            >
              {isPainScoreSubmitting ? (
                "Saving, Please Wait..."
              ) : (
                <span className="opacity-0">-</span>
              )}
            </div>

            <div className="mt-4 row g-0">
              <div
                className="col fs-6 text-start py-3 ps-4 fw-bold"
                style={{ backgroundColor: "#E8ECEF" }}
              >
                Score
              </div>
              <div
                className="col fs-5 text-center py-3 fw-bold"
                style={{ backgroundColor: "#0060A6", color: "#FFFFFF" }}
              >
                {score}
              </div>
            </div>
          </div>

          {/* <Link
            to="/pain-score/tracker"
            style={{ backgroundColor: "#E1F2FF", color: "#F6781B" }}
            className="d-block w-100 mt-2 py-4 text-center fs-6"
          >
            Track your pain score
          </Link> */}

          <div
            className={
              isASAssessmentEnabled && currentAppointment
                ? "mt-2 p-4 rounded"
                : "opacity-25 pe-none mt-2 p-4 rounded"
            }
            style={{ backgroundColor: "#FEF0E6" }}
          >
            <p className="fw-bold">Complete The Assessment</p>
            <Link
              to="/pain-score/ankylosing-spondylitis"
              style={{
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #F6781B",
                color: "#F6781B",
                padding: "6px 20px",
                fontSize: "16px",
                margin: "5px 0",
                borderRadius: 5,
              }}
              className="btn btn_outline"
            >
              Ankylosing Spondylitis
            </Link>
            <div className="d-flex align-items-center ">
              <p className="fs-8">
                Step-by-step guide for completing an assessment
              </p>
              <div className="text-red-500 text-2xl ">
                <YouTube
                  style={{ color: "red", widtht: "80px", fontSize: "50px" }}
                />
              </div>
            </div>
          </div>
          {/* <Link
            to="/pain-score/tracker/ankylosing-spondylitis"
            style={{
              backgroundColor: "#E1F2FF",
              color: "#F6781B",
            }}
            className="d-block w-100 mt-2 py-4 text-center fs-6 "
          >
            Track your Ankylosing Spondylitis Pain
          </Link> */}
          <div
            className={
              isRAAssessmentEnabled && currentAppointment
                ? "mt-2 p-4 rounded"
                : "opacity-25 pe-none mt-2 p-4 rounded"
            }
            style={{ backgroundColor: "#FEF0E6" }}
          >
            <p className="fw-bold">Complete The Assessment</p>
            <Link
              to="/pain-score/rheumatoid-arthritis"
              style={{
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #F6781B",
                color: "#F6781B",
                padding: "6px 20px",
                fontSize: "16px",
                margin: "5px 0",
                borderRadius: 5,
              }}
              className="btn btn_outline"
            >
              Rheumatoid Arthritis
            </Link>
            <div className="d-flex align-items-center ">
              <p className="fs-8">
                Step-by-step guide for completing an assessment
              </p>
              <div className="text-red-500 text-2xl ">
                <YouTube
                  style={{ color: "red", widtht: "80px", fontSize: "50px" }}
                />
              </div>
            </div>
          </div>
          {/* <Link
            to="/pain-score/tracker/rheumatoid-arthritis"
            style={{
              backgroundColor: "#E1F2FF",
              color: "#F6781B",
            }}
            className="d-block w-100 mt-2 py-4 text-center fs-6 "
          >
            Track your Rheumatoid Arthritis Pain
          </Link> */}
        </div>
      )}
    </>
  );
};

export default PainScore;
